import type { SuburbInput } from "@repo/adapter-core";
import type { SoldOnlyAdapterConfig } from "../shared/sold-only.ts";

export function buildSearchUrl(suburb: SuburbInput, _config: SoldOnlyAdapterConfig): string {
  return `https://www.marshallwhite.com.au/sold/?suburb=${encodeURIComponent(suburb.locality)}`;
}
